export default {"src":"/_next/static/media/OnlyFans.a3c286fd.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};